import toast from 'react-hot-toast';

import { getStudentRegistrations } from './../api'
import { useEffect, useState } from 'react'


export default function useGetStudentRegistrations() {
  const [registrations, setRegistrations] = useState([])
  const [loading, setLoading] = useState(false)

  async function fetchAnalytics() {
    setLoading(true)
    try {
      const res = await getStudentRegistrations()
      setRegistrations(res)

    } catch (err) {
      toast.error(err.message || 'Failed to fetch student registrations')
    } finally {
      setLoading(false)
    }
  }


  useEffect(() => {
    fetchAnalytics()
  }, [])

  return { data: registrations, isLoading: loading }
}